import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAddShipmentRefundMutation } from "store/services/PaymentsApi/shipmentRefundApi";
import ShipmentRefundForm from "./ShipmentRefundComponents/ShipmentRefundForm";

const ShipmentRefundCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Shipment Refunds", path: "/app/crm/shipment-refund/list" },
    { title: "New Refund" },
  ];

  const [addShipmentRefund, { isLoading }] = useAddShipmentRefundMutation();

  const handleCreateShipmentRefund = async (data) => {
    try {
      const { _id } = await addShipmentRefund(data).unwrap();
      toast.success("Shipment Refund successfully created!");
      navigate(`/app/crm/shipment-refund/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create Shipment Refund!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <ShipmentRefundForm
          isBusy={isLoading}
          onSubmit={handleCreateShipmentRefund}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ShipmentRefundCreateScreen;